export default __webpack_public_path__ + "static/media/thumbnail.553173a1.png";